var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoH(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 132,
    viewBox: "0 0 130 132",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M92.5624 71.3418L57.6574 131.414L40.3743 85.4084L0.385986 60.4691L43.5598 39.6071L29.8689 61.2166L53.1163 76.9821L60.3685 98.116L73.246 87.9228L92.5624 71.3418Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M92.5624 71.3418L57.6574 131.414L40.3743 85.4084L0.385986 60.4691L43.5598 39.6071L29.8689 61.2166L53.1163 76.9821L60.3685 98.116L73.246 87.9228L92.5624 71.3418Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2899 59.4501L73.7883 0.465576L89.5803 46.4708L129.772 72.3615L86.8015 93.7672L101.373 71.8179L77.5838 57.0038L69.8573 35.0545L53.3197 49.4608L39.2899 59.4501Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2899 59.4501L73.7883 0.465576L89.5803 46.4708L129.772 72.3615L86.8015 93.7672L101.373 71.8179L77.5838 57.0038L69.8573 35.0545L53.3197 49.4608L39.2899 59.4501Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoH);
export default __webpack_public_path__ + "static/media/logoH.2a2ca8eb851c7d9951470f23e6e603f3.svg";
export { ForwardRef as ReactComponent };